import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import LaCarte from './pages/LaCarte';
import FicheProduit from './pages/FicheProduit';
import MentionsLegales from './components/MentionsLegales';
import PolitiqueConfidentialite from './components/PolitiqueConfidentialite';
import NotreConception from './pages/NotreConception';
import Localisation from './pages/Localisation';
import Tablette from './pages/Tablette';
import PolitiqueCookies from './pages/PolitiqueCookies';
import NotFound from './pages/NotFound';
import Contact from './pages/Contact';
import CookieBanner from './components/CookieBanner';
import './App.css';

// Commande en ligne désactivée : /commander, /success et /cgv restent dans le code
// (voir src/pages/Commander.jsx, src/pages/Success.jsx, src/pages/CGV.jsx) mais ne sont plus routés.

function App() {
  return (
    <BrowserRouter>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/la-carte" element={<LaCarte />} />
        <Route path="/produit/:id" element={<FicheProduit />} />
        <Route path="/notre-concept" element={<NotreConception />} />
        <Route path="/localisation" element={<Localisation />} />
        <Route path="/commander" element={<Navigate to="/" replace />} />
        <Route path="/tablette" element={<Tablette />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/success" element={<Navigate to="/" replace />} />
        <Route path="/cgv" element={<Navigate to="/" replace />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/politique-cookies" element={<PolitiqueCookies />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
